import React from 'react';

interface DashboardHeaderProps {
  children?: React.ReactNode;
  icon?: React.ReactNode;
  title?: string;
  actions?: React.ReactNode;
  action?: React.ReactNode;
}

export const DashboardHeader = ({
  children,
  icon,
  title,
  actions,
  action,
}: DashboardHeaderProps) => {
  return (
    <div className="bg-transparent h-[72px] relative">
      <div className="absolute bottom-0 left-0 right-0 h-16 rounded-t-xl">
        <div className="flex items-center justify-between h-full px-10">
          {children || (
            <>
              <div className="flex items-center gap-2.5">
                {icon}
                <span className="text-white font-bold text-sm">{title}</span>
              </div>
              {actions || action}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
